import { createContext } from "react";

export const CollapsedContext = createContext(false);
